export default {
  CREATING_BID: "f-n-1",
  PURCHASE_PROCESS: "f-n-2",
  CREATING_TOKEN: "f-n-3",
  DELETING_FILE: "f-n-4",
};
